var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.593 7.695"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    "data-name": "Icon - Live",
    transform: "translate(.75 .768)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.029,
    height: 6.092,
    "data-name": "Rectangle 229",
    rx: 1.406,
    transform: "translate(0 .033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.898.033L7.03 1.824V4.13l3.87 1.992c.106.082.193.018.193-.141v-5.8c0-.16-.087-.227-.195-.148z",
    "data-name": "Path 407"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMi41OTMgNy42OTUiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgZGF0YS1uYW1lPSJJY29uIC0gTGl2ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjc1IC43NjgpIj48cmVjdCB3aWR0aD0iNy4wMjkiIGhlaWdodD0iNi4wOTIiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDIyOSIgcng9IjEuNDA2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC4wMzMpIi8+PHBhdGggZD0iTTEwLjg5OC4wMzMgNy4wMyAxLjgyNFY0LjEzbDMuODcgMS45OTJjLjEwNi4wODIuMTkzLjAxOC4xOTMtLjE0MXYtNS44YzAtLjE2LS4wODctLjIyNy0uMTk1LS4xNDhaIiBkYXRhLW5hbWU9IlBhdGggNDA3Ii8+PC9nPjwvc3ZnPgo=";
export { SvgIconLive as ReactComponent };